var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildPreschooler({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.40613,
    height: 126.406,
    viewBox: "0 0 126.40613 126.406",
    sodipodidocname: "Child-Preshooler.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.805 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "Child-Preshooler",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(47.3996,56.0945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 0.018 0.019 C 6.045,0.01 10.597,4.598 10.607,10.674 10.611,13.48 9.49,16.145 7.451,18.18 5.453,20.175 2.856,21.272 0.137,21.272 H 0.099 C -5.816,21.25 -10.617,16.479 -10.602,10.637 -10.586,4.669 -5.931,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(60.4911,52.2423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -1.514,1.483 -3.291,2.514 -5.403,2.725 -7.592,1.298 -10.215,0.466 -13.068,0.462 h -0.024 c -2.862,0 -5.494,0.829 -7.689,2.257 -1.874,-0.212 -3.514,-1.055 -4.875,-2.364 -3.292,-3.167 -6.529,-6.394 -9.695,-9.688 -1.553,-1.615 -1.342,-4.226 0.247,-5.808 0.948,-0.944 2.05,-1.433 3.148,-1.433 0.959,0 1.913,0.372 2.759,1.139 1.671,1.513 3.221,3.16 4.837,4.734 0.287,0.28 0.637,0.495 1.126,0.868 0,-8.494 -0.01,-11.926 0.006,-20.159 0.005,-2.792 1.858,-4.805 4.355,-4.812 0.004,0 0.008,0 0.012,0 2.478,0 4.403,2.054 4.423,4.769 0.021,2.877 0.014,5.755 0.001,8.632 -0.005,0.977 0.136,1.957 1.309,1.983 0.018,0.001 0.036,0.001 0.053,0.001 1.242,0 1.369,-1.012 1.364,-2.04 -0.017,-2.99 -0.044,-5.981 0.011,-8.971 0.038,-2.12 1.422,-3.728 3.478,-4.232 0.318,-0.078 0.643,-0.116 0.966,-0.116 1.507,0 2.994,0.827 3.725,2.294 0.407,0.816 0.584,1.827 0.589,2.751 0.044,8.118 0.026,11.436 0.026,19.554 0.201,0.145 0.402,0.291 0.603,0.436 1.588,-1.743 3.141,-3.518 4.775,-5.215 0.903,-0.937 1.979,-1.591 3.28,-1.591 0.212,0 0.429,0.017 0.653,0.053 1.679,0.271 2.954,1.146 3.543,2.769 0.687,1.894 0.135,3.566 -1.232,4.961 C 5.825,-5.824 2.943,-2.881 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(73.6161,37.3587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.985,-2.713 -3.183,-4.474 -6.19,-4.96 -0.397,-0.064 -0.798,-0.096 -1.193,-0.096 -1.349,0 -3.316,0.392 -5.265,2.182 0.003,-5.531 0.002,-6.402 -0.028,-11.994 -0.006,-1.083 -0.175,-2.7 -0.945,-4.245 -1.284,-2.574 -3.874,-4.172 -6.76,-4.172 -0.599,0 -1.195,0.072 -1.773,0.214 -1.652,0.405 -3.046,1.236 -4.079,2.368 -1.422,-1.612 -3.468,-2.608 -5.774,-2.608 -4.402,0.012 -7.728,3.536 -7.737,8.196 -0.011,5.678 -0.009,6.556 -0.007,12.319 -0.098,-0.09 -0.196,-0.18 -0.295,-0.269 -1.456,-1.319 -3.197,-2.016 -5.035,-2.016 -2.005,0 -3.973,0.86 -5.54,2.421 -2.945,2.932 -3.079,7.669 -0.299,10.561 3.097,3.222 6.391,6.513 9.789,9.781 1.238,1.191 2.644,2.08 4.154,2.646 -2.016,2.423 -3.223,5.561 -3.232,9.036 -0.02,7.71 6.296,14.006 14.079,14.034 h 0.05 c 3.624,0 7.071,-1.448 9.71,-4.082 2.683,-2.677 4.157,-6.197 4.151,-9.912 -0.006,-3.476 -1.21,-6.619 -3.223,-9.05 1.67,-0.612 3.24,-1.629 4.689,-3.047 2.97,-2.908 5.912,-5.912 8.757,-8.817 C 0.358,6.086 1.086,2.991 0,0 m -3.332,51.547 c -22.921,12.638 -51.748,4.301 -64.385,-18.621 -12.638,-22.922 -4.301,-51.748 18.621,-64.386 22.921,-12.637 51.748,-4.301 64.386,18.621 12.637,22.922 4.3,51.749 -18.622,64.386",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildPreschooler);
export default __webpack_public_path__ + "static/media/child_preschooler.6e29bcd5f4fbaf2316d9a781f6c853f4.svg";
export { ForwardRef as ReactComponent };